export { default } from "./ListComp";

